jQuery(function($){
	$(document).ready(function(e){
		const checkMenuLoaded = setInterval(function(){
			if( $('.image-banner-menu').length > 0 ) {
				clearInterval(checkMenuLoaded);
				$('.image-banner-menu').each(function(e) {
					$(this).find("img").wrap( "<div class='img-wrap'></div>" )
				});
			}
		}, 100);
		
		const checkMenuTitleLoaded = setInterval(function(){
			if( $('.gm-item a[title]').length > 0 ) {
				clearInterval(checkMenuTitleLoaded);
				$(".gm-item a[title]").each(function(e) {
					var thisTitle = $(this).attr('title');
					$(this).attr('aria-label',thisTitle);
					$(this).removeAttr("title");
                  console.log("goog")
				});
			}
		}, 100);
    })
})